/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.24",
    versionName: "0.2.0-nightly.2025.7.24",
    versionChannel: "nightly",
    buildDate: "2025-07-24T00:07:46.666Z",
    commitHash: "f032b6a5d1759ad36b1f279532a80d0ac438a07b",
};
